import type { CcoServiceModel } from '@core/services/cco/cco.service';
import type { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { of } from 'rxjs';

@Injectable()
export class CcoServiceImpl implements CcoServiceModel {
  //TODO move
  getCcoImages = (): Observable<string[]> =>
    of([
      'https://storage.googleapis.com/wizbii-images/money/app/cco/julie.png',
      'https://storage.googleapis.com/wizbii-images/money/app/cco/charlotte.png',
      'https://storage.googleapis.com/wizbii-images/money/app/cco/mayline.png',
      'https://storage.googleapis.com/wizbii-images/money/app/cco/margaux-goy.png',
      'https://storage.googleapis.com/wizbii-images/money/app/cco/anais.png',
    ]);
}
